// String
export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const convertToStringOrNull = (newValue: unknown): string | null => {
  if (
    newValue === null ||
    (typeof newValue === 'string' && newValue.length > 0)
  ) {
    return newValue;
  }

  if (typeof newValue === 'number') {
    return newValue.toString();
  }

  return null;
};

export const validText = (text: string) => {
  if (text === '' || text.length < 1) {
    return false;
  } else {
    return true;
  }
};
